import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Stores
import { IAppState } from "../../../types/stores";

// Actions
import { AddFieldLabel } from "../../../actions/fieldLabelsActions";
import { notifyError } from "../../../actions/notifyActions";

// Material Styles
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

// Material UI
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { ColorButton } from "../../material-components/Misc/Button";

const theme = createTheme({
    overrides: {
        MuiInput: {
            underline: {
                "&&&&:hover:after": {
                    borderBottom: "2px solid #406eb3",
                },
                "&&&&:after": {
                    borderBottom: "2px solid #406eb3",
                },
            },
        },
    },
});

// Types and Interfaces
interface LabelType {
    LabelTypeId: number;
    LabelTypeName: string;
}

const FieldLabelAdd: React.FC<{}> = () => {
    const dispatch = useDispatch();

    // State
    const [name, setName] = useState("");
    const [type, setType] = useState(0);

    // Props
    const labels = useSelector((state: IAppState) => state.fieldLabels.labels);
    const labelTypes = useSelector((state: IAppState) => state.fieldLabels.labelTypes);

    // Functions
    const handleChangeName = (newValue: string) => {
        setName(newValue);
    };

    const handleChangeType = (newValue: number) => {
        setType(newValue);
    };

    const validate = () => {
        if (!labels || (labels && labels.length <= 0)) return true;

        const labelsCopy = [...labels].map(x => ({ ...x }));
        const alreadyExists = labelsCopy.some(item => item.FieldLabelName.toUpperCase() == name.toUpperCase());

        return !alreadyExists;
    };

    const save = () => {
        if (!validate()) {
            showConfirm(name);
            return;
        }

        dispatch(AddFieldLabel(name, type));
        resetValues();
    };

    const showConfirm = (newValue: string) => {
        let modalText = `There is already a field label name  ${newValue} . Please create a different name.`;
        dispatch(notifyError(modalText));
    };

    const resetValues = () => {
        setName("");
        setType(0);
    };

    return (
        <div>
            <div style={{ display: "flex", width: "100%", paddingTop: "20px" }}>
                <ThemeProvider theme={theme}>
                    <FormControl style={{ minWidth: "15vw", paddingRight: "10px" }}>
                        <TextField
                            inputProps={{ style: { fontSize: "15px" }, maxLength: 128 }}
                            label={"Name"}
                            type="text"
                            value={name}
                            onChange={e => handleChangeName(e.target.value)}
                        />
                    </FormControl>
                    <FormControl style={{ minWidth: "15vw", paddingRight: "10px" }}>
                        <InputLabel>Type</InputLabel>
                        <Select
                            style={{ fontSize: "14px" }}
                            value={type}
                            onChange={e => handleChangeType(parseInt(e.target.value as string))}
                            displayEmpty
                        >
                            {labelTypes.map((x: LabelType) => (
                                <MenuItem key={`${"type_"}${x.LabelTypeId}`} value={x.LabelTypeId}>
                                    {x.LabelTypeName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl style={{ minWidth: "5vw", padding: "10px" }}>
                        <ColorButton
                            style={{
                                fontSize: "14px",
                                fontWeight: "normal",
                                height: "100%",
                            }}
                            onClick={save}
                            backgroundcolor="#406eb3"
                            disabled={!name}
                        >
                            <span style={{ padding: "0px 1px" }}>Add</span>
                        </ColorButton>
                    </FormControl>
                </ThemeProvider>
            </div>
        </div>
    );
};

export default FieldLabelAdd;
